<template>
  <card :title="title" v-loading="loading.userEvents">
    <el-select
      v-model="query"
      filterable
      clearable
      placeholder="Filter by Event name..."
    >
      <el-option
        v-for="event in events"
        :key="event"
        :value="event"
        :label="event"
      />
    </el-select>
    <Table :items="userEvents.results" :columns="columns" :actions="actions" />
    <div class="pagination">
      <el-pagination
        layout="prev, pager, next"
        :page-size="20"
        :current-page="userEvents.page + 1"
        :total="userEvents.total"
        @current-change="fetchData"
      />
    </div>
  </card>
</template>

<script>
import { isEmpty } from "lodash";
import { mapGetters, mapActions } from "vuex";
import Card from "@/components/Card";
import Table from "@/components/Table";
import copy from "@/utils/copy";
import { deserializeDate, timeSince } from "@/utils/time";

export default {
  data() {
    return {
      columns: [
        { label: "Time", prop: "created_at" },
        {
          label: "Time Passed",
          formatter: (props) =>
            `${timeSince(deserializeDate(props.created_at))} ago`,
        },
        { label: "Event", prop: "event_action" },
      ],
      actions: [
        {
          name: "Copy ID",
          onClick: (item) => {
            copy(item.id);
            this.$notify.success("Copied!");
          },
        },
        {
          name: "View params",
          onClick: (item) => {
            const title = `${item.created_at} ${item.event_action} params`;
            const content = JSON.stringify(item.params, null, " ");
            const message = `
                    <div style="width:100%; background: #F5F5F5;">
                        <code style="word-break: break-word;">
                            ${content}
                        </code>
                    </div>`;
            this.$alert(message, { title, dangerouslyUseHTMLString: true });
          },
        },
      ],
      query: "",
    };
  },
  components: {
    Card,
    Table,
  },
  mounted() {
    if (isEmpty(this.events)) this.getEvents();
    this.fetchData();
  },
  computed: {
    ...mapGetters(["userEvents", "events", "loading"]),
    title() {
      const { userEvents } = this;
      if (!userEvents || !userEvents.total) return "events";
      return `events (${userEvents.total.toLocaleString()} results)`;
    },
  },
  methods: {
    ...mapActions(["getUserEvents", "getEvents"]),
    async fetchData(currentPage) {
      const { query: q } = this;
      const { query: id } = this.$route.params;
      await this.getUserEvents({ id, page: currentPage - 1, q });
    },
  },
  watch: {
    query() {
      this.fetchData(1);
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
